import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert'
import history from 'utils/history'

import Form from '../components/Form'
import Heading from '../components/Heading'
import { DatasourceProvider, useDatasourceStore } from '../store';

const DatasourcePropTypes = {
  match: PropTypes.object,
}

const DatasourceForm = () => {
  const { id } = useParams()
  const [slugs, setSlugs] = useState([])
  const {
    collection: { item, useLoad, useSubmit, reset }, test,
    lists: { datasources: { useLoad: useLoadAll, items: datasources } },
  } = useDatasourceStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  useLoad(id)
  useLoadAll()
  const handleSubmit = useSubmit()

  const handleSubmitAndClose = useCallback(async (payload, isTest) => {
    if (isTest) return await test(payload)

    try {
      if (!payload.mapping) {
        return handleError('Error', 'The mapping is required')
      }

      if (payload.needTest) {
        return handleError('Error', 'Before save try test the request and get a successful reponse.')
      }

      await handleSubmit({ ...payload, active })
      history.push('/settings/datasources')
      reset()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Datasource ${message}.`)
    } catch (error) {
      handleError('Error', 'Datasource was not saved.')
    }
  }, [handleSubmit, test, reset, handleSuccess, handleError, active])

  const loadSlugs = useCallback(async () => {
    if (slugs && slugs.length) return slugs
    const allSlugs = datasources.filter(data => data.id !== id).map(({ slug }) => slug)
    setSlugs(allSlugs)
    return allSlugs
  }, [id, slugs, datasources])

  if (!item) {
    return null
  }

  return <FormWrapper title="Datasource">
    <Heading data={item} active={active} onChangeActive={setActive} />
    <Form data={item} handleSubmit={handleSubmitAndClose} loadSlugs={loadSlugs} />
  </FormWrapper>
}

DatasourceForm.propTypes = DatasourcePropTypes

export default function DatasourceFormLayout() {
  return <DatasourceProvider>
    <DatasourceForm />
  </DatasourceProvider>;
}
